/* eslint-disable no-debugger */
//import { isValidDate, isValidBirthDate } from '@usas/ui-web/utils/validation';

export const localValidate = (formState) => {
  let errors = {};


  //New club
  if (formState.isNew === true) {
    if (
      formState.preEmploymentScreeningRequired === false || 
      formState.racingStartCertified === false ||
      formState.stateConcussionsLaws === false || 
      formState.minorAthleteAbusePreventionPolicy === false ||
      formState.applicationAcknowledgement === false
    ) {
      errors.general = 'Must select yes for all screening & policies'
    }
  }

  if (formState.acknowledgementsSignature.trim() === '') {
    errors.acknowledgementsSignature = 'Signature is required'
  }


  return errors;
};

const ClubRegistrationScreeningPoliciesValidation = async (formState) => {
  let errors = localValidate(formState);

  return errors ? errors : {};
}

export default ClubRegistrationScreeningPoliciesValidation;